export const GET_BASIC_DATA_FOR_PLANNER_DASHBOARD_REQUEST =
  "GET_BASIC_DATA_FOR_PLANNER_DASHBOARD_REQUEST";
export const GET_BASIC_DATA_FOR_PLANNER_DASHBOARD_SUCCESS =
  "GET_BASIC_DATA_FOR_PLANNER_DASHBOARD_SUCCESS";
export const GET_BASIC_DATA_FOR_PLANNER_DASHBOARD_ERROR =
  "GET_BASIC_DATA_FOR_PLANNER_DASHBOARD_ERROR";

export const GET_SLOT_DELIVERY_DATA_DAYWISE_FOR_PLANNER_DASHBOARD_REQUEST =
  "GET_SLOT_DELIVERY_DATA_DAYWISE_FOR_PLANNER_DASHBOARD_REQUEST";
export const GET_SLOT_DELIVERY_DATA_DAYWISE_FOR_PLANNER_DASHBOARD_SUCCESS =
  "GET_SLOT_DELIVERY_DATA_DAYWISE_FOR_PLANNER_DASHBOARD_SUCCESS";
export const GET_SLOT_DELIVERY_DATA_DAYWISE_FOR_PLANNER_DASHBOARD_ERROR =
  "GET_SLOT_DELIVERY_DATA_DAYWISE_FOR_PLANNER_DASHBOARD_ERROR";

export const GET_AUDIENCE_DATA_FOR_PLANNER_DASHBOARD_REQUEST =
  "GET_AUDIENCE_DATA_FOR_PLANNER_DASHBOARD_REQUEST";
export const GET_AUDIENCE_DATA_FOR_PLANNER_DASHBOARD_SUCCESS =
  "GET_AUDIENCE_DATA_FOR_PLANNER_DASHBOARD_SUCCESS";
export const GET_AUDIENCE_DATA_FOR_PLANNER_DASHBOARD_ERROR =
  "GET_AUDIENCE_DATA_FOR_PLANNER_DASHBOARD_ERROR";

export const GET_HARDWARE_PERFORMANCE_DATA_FOR_PLANNER_DASHBOARD_REQUEST =
  "GET_HARDWARE_PERFORMANCE_DATA_FOR_PLANNER_DASHBOARD_REQUEST";
export const GET_HARDWARE_PERFORMANCE_DATA_FOR_PLANNER_DASHBOARD_SUCCESS =
  "GET_HARDWARE_PERFORMANCE_DATA_FOR_PLANNER_DASHBOARD_SUCCESS";
export const GET_HARDWARE_PERFORMANCE_DATA_FOR_PLANNER_DASHBOARD_ERROR =
  "GET_HARDWARE_PERFORMANCE_DATA_FOR_PLANNER_DASHBOARD_ERROR";

export const GET_SPOT_DELIVERY_DATA_FOR_PLANNER_DASHBOARD_REQUEST =
  "GET_SPOT_DELIVERY_DATA_FOR_PLANNER_DASHBOARD_REQUEST";
export const GET_SPOT_DELIVERY_DATA_FOR_PLANNER_DASHBOARD_SUCCESS =
  "GET_SPOT_DELIVERY_DATA_FOR_PLANNER_DASHBOARD_SUCCESS";
export const GET_SPOT_DELIVERY_DATA_FOR_PLANNER_DASHBOARD_ERROR =
  "GET_SPOT_DELIVERY_DATA_FOR_PLANNER_DASHBOARD_ERROR";

export const GET_COST_DATA_FOR_PLANNER_DASHBOARD_REQUEST =
  "GET_COST_DATA_FOR_PLANNER_DASHBOARD_REQUEST";
export const GET_COST_DATA_FOR_PLANNER_DASHBOARD_SUCCESS =
  "GET_COST_DATA_FOR_PLANNER_DASHBOARD_SUCCESS";
export const GET_COST_DATA_FOR_PLANNER_DASHBOARD_ERROR =
  "GET_COST_DATA_FOR_PLANNER_DASHBOARD_ERROR";

export const GET_SITE_LEVEL_PERFORMANCE_DATA_FOR_PLANNER_DASHBOARD_REQUEST =
  "GET_SITE_LEVEL_PERFORMANCE_DATA_FOR_PLANNER_DASHBOARD_REQUEST";
export const GET_SITE_LEVEL_PERFORMANCE_DATA_FOR_PLANNER_DASHBOARD_SUCCESS =
  "GET_SITE_LEVEL_PERFORMANCE_DATA_FOR_PLANNER_DASHBOARD_SUCCESS";
export const GET_SITE_LEVEL_PERFORMANCE_DATA_FOR_PLANNER_DASHBOARD_ERROR =
  "GET_SITE_LEVEL_PERFORMANCE_DATA_FOR_PLANNER_DASHBOARD_ERROR";

export const GET_SITE_LEVEL_PERFORMANCE_DATA_TAB_WISE_FOR_PLANNER_DASHBOARD_REQUEST =
  "GET_SITE_LEVEL_PERFORMANCE_DATA_TAB_WISE_FOR_PLANNER_DASHBOARD_REQUEST";
export const GET_SITE_LEVEL_PERFORMANCE_DATA_TAB_WISE_FOR_PLANNER_DASHBOARD_SUCCESS =
  "GET_SITE_LEVEL_PERFORMANCE_DATA_TAB_WISE_FOR_PLANNER_DASHBOARD_SUCCESS";
export const GET_SITE_LEVEL_PERFORMANCE_DATA_TAB_WISE_FOR_PLANNER_DASHBOARD_ERROR =
  "GET_SITE_LEVEL_PERFORMANCE_DATA_TAB_WISE_FOR_PLANNER_DASHBOARD_ERROR";
export const GET_SITE_LEVEL_PERFORMANCE_DATA_TAB_WISE_FOR_PLANNER_DASHBOARD_RESET =
  "GET_SITE_LEVEL_PERFORMANCE_DATA_TAB_WISE_FOR_PLANNER_DASHBOARD_RESET";

export const GET_SITE_DATA_MAP_VIEW_FOR_PLANNER_DASHBOARD_REQUEST =
  "GET_SITE_DATA_MAP_VIEW_FOR_PLANNER_DASHBOARD_REQUEST";
export const GET_SITE_DATA_MAP_VIEW_FOR_PLANNER_DASHBOARD_SUCCESS =
  "GET_SITE_DATA_MAP_VIEW_FOR_PLANNER_DASHBOARD_SUCCESS";
export const GET_SITE_DATA_MAP_VIEW_FOR_PLANNER_DASHBOARD_ERROR =
  "GET_SITE_DATA_MAP_VIEW_FOR_PLANNER_DASHBOARD_ERROR";

export const GET_SITE_MONITORING_PICS_PERCENTAGE_REQUEST =
  "GET_SITE_MONITORING_PICS_PERCENTAGE_REQUEST";
export const GET_SITE_MONITORING_PICS_PERCENTAGE_SUCCESS =
  "GET_SITE_MONITORING_PICS_PERCENTAGE_SUCCESS";
export const GET_SITE_MONITORING_PICS_PERCENTAGE_ERROR =
  "GET_SITE_MONITORING_PICS_PERCENTAGE_ERROR";

export const GET_ALL_SITE_MONITORING_DATA_REQUEST =
  "GET_ALL_SITE_MONITORING_DATA_REQUEST";
export const GET_ALL_SITE_MONITORING_DATA_SUCCESS =
  "GET_ALL_SITE_MONITORING_DATA_SUCCESS";
export const GET_ALL_SITE_MONITORING_DATA_FAIL =
  "GET_ALL_SITE_MONITORING_DATA_FAIL";

export const GET_SITE_BASED_DATA_ON_LOGS_PAGE_REQUEST =
  "GET_SITE_BASED_DATA_ON_LOGS_PAGE_REQUEST";
export const GET_SITE_BASED_DATA_ON_LOGS_PAGE_SUCCESS =
  "GET_SITE_BASED_DATA_ON_LOGS_PAGE_SUCCESS";
export const GET_SITE_BASED_DATA_ON_LOGS_PAGE_FAIL =
  "GET_SITE_BASED_DATA_ON_LOGS_PAGE_FAIL";

export const GET_ALL_LOGS_FOR_POPUP_REQUEST = "GET_ALL_LOGS_FOR_POPUP_REQUEST";
export const GET_ALL_LOGS_FOR_POPUP_SUCCESS = "GET_ALL_LOGS_FOR_POPUP_SUCCESS";
export const GET_ALL_LOGS_FOR_POPUP_FAIL = "GET_ALL_LOGS_FOR_POPUP_FAIL";

export const GET_CAMPAIGN_CREATIONS_DETAILS_REQUEST =
  "GET_CAMPAIGN_CREATIONS_DETAILS_REQUEST";
export const GET_CAMPAIGN_CREATIONS_DETAILS_SUCCESS =
  "GET_CAMPAIGN_CREATIONS_DETAILS_SUCCESS";
export const GET_CAMPAIGN_CREATIONS_DETAILS_ERROR =
  "GET_CAMPAIGN_CREATIONS_DETAILS_ERROR";
export const GET_CAMPAIGN_CREATIONS_DETAILS_RESET =
  "GET_CAMPAIGN_CREATIONS_DETAILS_RESET";
